<template>
    <div class="chat__contact px-2 pt-4 pb-2" @click="$emit('addToSelected', user.key)">
      <div class="flex items-center">
        <div class="contact__avatar mr-1">
            <vs-avatar class="border-2 border-solid border-white" :src="user.photoURL" size="42px" />
        </div>

        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info flex flex-col truncate w-full pr-3">
                <div class="flex justify-between">
                    <h5 class="font-semibold truncate">{{ user.name }}</h5>
                    <span class="font-bold">{{user.roleName}}</span>
                </div>
                
                <span class="truncate"><span class="font-bold">{{$t(`ACCESTOKENS.created`)}}:</span> {{ user.created | formatDate }}</span>
                <span class="truncate hidden sm:block"><span class="font-bold">{{$t(`ACCESTOKENS.Email`)}}:</span> {{user.email}} </span>
                <span class="truncate block sm:hidden"><span class="font-bold">Tel.:</span> {{user.phone}} </span>
            </div>
            <div>     
                <!-- <vs-radio :disabled="disabled" @click.stop v-model="isSelectedBota" class="vs-checkbox-small ml-0 mr-1"  :vs-value="bot.id"></vs-radio>          -->
                <!-- <vs-checkbox  v-model="isSelectedBot" @click.stop class="vs-checkbox-small ml-0 mr-1" :vs-value="bot.id"></vs-checkbox>  -->
            </div>
        </div>
      </div> 

      <div class="flex flex-col md:flex-row  w-full">
        <div class="flex items-center mr-5 mt-3 hidden sm:block">               
            <feather-icon icon="PhoneIcon" class="cursor-pointer text-warning text-sm"></feather-icon>
            <span class="ml-3 text-sm">{{user.phone}}</span>
        </div> 
        <div class="flex items-center mr-5 mt-3 block sm:hidden">               
            <feather-icon icon="MailIcon" class="cursor-pointer text-warning text-sm"></feather-icon>
            <span class="ml-3 text-sm">{{user.email}}</span>
        </div>
        <div class="flex items-center mr-5 mt-3">               
            <feather-icon icon="KeyIcon" class="cursor-pointer text-warning text-sm"></feather-icon>
            <span class="ml-3 text-sm">{{user.key}}</span>
        </div>                  
      </div>      
    </div>
</template>

<script>
import DateUtils from '@/helpers/DateUtils';
export default {
  props: {
    user: { 
        type: Object,  
        required: true 
    }
  },
  filters: {
      formatDate(date) {
          return DateUtils.toDefaultDateTime(date, 'DD MMM YYYY');
      }
  }, 
  computed: {
    isSelectedBota: {
      get() {
        return this.isSelected;
      },
      set(value) {
        this.$emit('addToSelected', value)
      }
    }
  }, 
}
</script>

